import _ from "lodash";
import { Types } from "../actions/adminActions";

const adminReducers = (state, action) => {
	switch (action.type) {
		case Types.ADMIN_GET_USER: {
			let newState = _.cloneDeep(state);

			newState.admin.getUser = action.payload;

			return newState;
		}

		case Types.ADMIN_GET_USER_MODAL: {
			let newState = _.cloneDeep(state);

			newState.admin.getUserModal = action.toggle ? true : undefined;
			if (!action.toggle) newState.admin.getUser = undefined;

			return newState;
		}

		case Types.ADMIN_GET_CERTIFICATE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.admin.getCertificateModal = action.toggle ? true : undefined;
			if (!action.toggle) newState.admin.getCertificate = undefined;
			return newState;
		}

		case Types.ADMIN_UPDATE_ACCOUNT_STATUS: {
			let newState = _.cloneDeep(state);

			newState.company.settings.status = action.payload;

			return newState;
		}

		case Types.ADMIN_REMOVE_SAVED_PAYMENT_HANDLE: {
			let newState = _.cloneDeep(state);

			newState.admin.paymentHandles = newState.admin?.paymentHandles?.filter(
				(handle) => handle.id !== action.payload,
			);

			return newState;
		}

		case Types.ADMIN_SET_PAYMENT_HANDLES: {
			let newState = _.cloneDeep(state);

			newState.admin.paymentHandles = action.payload;

			return newState;
		}

		case Types.ADMIN_GET_PAYMENT_HANDLE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.admin.paymentHandleModal = action.payload;

			return newState;
		}

		case Types.ADMIN_GET_CREATE_NOTIFICATION_MODAL: {
			let newState = _.cloneDeep(state);

			newState.admin.createNotificationModal = action.status;
			newState.admin.notificationId = action.notificationId;

			return newState;
		}

		case Types.ADMIN_UPDATE_NOTIFICATIONS: {
			let newState = _.cloneDeep(state);

			newState.admin.notifications = action.payload;

			return newState;
		}

		case Types.ADMIN_GET_BILLING_EMAILS: {
			let newState = _.cloneDeep(state);

			newState.admin.billingEmails = action.payload;

			return newState;
		}

		default:
			return state;
	}
};

export default adminReducers;
